class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartClose extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      this.closest('cart-drawer').close();
    });
  }
}

customElements.define('cart-close', CartClose);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.querySelector('.page-overlay');
    
    this.openButtons = document.querySelectorAll('.js-open-cart');
    this.closeButtons = document.querySelectorAll('.js-close-cart');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this._handleOutsideClick = (e) => {
      if (window.innerWidth < 1024) return;
      if (!this.drawer.contains(e.target)) this.close();
    };

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.openButtons.forEach(button => button.addEventListener('click', this.open.bind(this)));
    this.closeButtons.forEach(button => button.addEventListener('click', this.close.bind(this)));
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.overlay.classList.remove('invisible', 'opacity-0');
    this.overlay.addEventListener('click', () => this.close());

    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      document.addEventListener('pointerdown', this._handleOutsideClick);
    }, 0);
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded');

    this.overlay.classList.add('invisible', 'opacity-0');

    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('pointerdown', this._handleOutsideClick);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const EXPEDITE_TIERS = [
      { max: 24999,  id: 51467452743926 },
      { max: 50000,  id: 51467452776694 },
      { max: 75000,  id: 51467452809462 },
      { max: 100000, id: 51467452842230 },
      { max: null,   id: 51467452874998 }
    ];
    const EXPEDITE_ALL = EXPEDITE_TIERS.map((t) => t.id);
    const pickTier = (base) => {
      for (let i = 0; i < EXPEDITE_TIERS.length; i++) {
        if (EXPEDITE_TIERS[i].max === null || base <= EXPEDITE_TIERS[i].max) return EXPEDITE_TIERS[i];
      }
      return EXPEDITE_TIERS[EXPEDITE_TIERS.length - 1];
    };

    const sections = getSectionsToRender().map((section) => section.section);
    const sectionsUrl = window.location.pathname;

    const changeBody = JSON.stringify({ line, quantity, sections, sections_url: sectionsUrl });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: changeBody } })
      .then((response) => response.json())
      .then((cart) => {
        let exp = null;
        let base = cart.total_price;
        (cart.items || []).forEach((it) => {
          if (EXPEDITE_ALL.indexOf(it.id) !== -1) { exp = it; base -= it.final_line_price; }
        });

        if (base < 0) base = 0;

        if (!exp || exp.id === pickTier(base).id) {
          this.renderSections(cart);
          this.disableLoading();
          return;
        }

        const want = pickTier(base);
        const updates = {};
        EXPEDITE_ALL.forEach((id) => { updates[String(id)] = 0; });
        updates[String(want.id)] = 1;

        return fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body: JSON.stringify({ updates, sections, sections_url: sectionsUrl }) }
        })
          .then((r) => r.json())
          .then((updatedCart) => {
            this.renderSections(updatedCart);
            this.disableLoading();
          });
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  renderSections(parsedState) {
    if (!parsedState.sections) return;
    getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
    });
  }

  enableLoading() {
    document.getElementById('cart-drawer-loading').classList.remove('hidden');
  }

  disableLoading() {
    document.getElementById('cart-drawer-loading').classList.add('hidden');
  }
}

customElements.define('cart-drawer', CartDrawer); 

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-expedite-remove]');
  if (!btn) return;
  event.preventDefault();
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const updates = {
    '51467452743926': 0, '51467452776694': 0, '51467452809462': 0,
    '51467452842230': 0, '51467452874998': 0
  };
  drawer.enableLoading();
  fetch(`${routes.cart_update_url || '/cart/update.js'}`, {
    ...fetchConfig(),
    ...{ body: JSON.stringify({
      updates,
      sections: getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname
    }) }
  })
    .then((r) => r.json())
    .then((cart) => {
      drawer.renderSections(cart);
      drawer.disableLoading();
      document.querySelectorAll('[data-expedite-trigger]').forEach((b) => { b.hidden = false; });
    })
    .catch(() => drawer.disableLoading());
});